import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import {DragulaModule} from 'ng2-dragula';

import {MediaCarouselComponent} from './media-carousel/media-carousel.component';
import {ObjectViewModule} from '../object-view/object-view.module';
import {SharedModule} from '../shared/shared.module';
import {ChangeMediaOrderComponent} from './change-media-order/change-media-order.component';
import {MediaSelectorModule} from '../media-selector/media-selector.module';
import {MatLegacySliderModule as MatSliderModule} from '@angular/material/legacy-slider';
import {MatLegacyButtonModule as MatButtonModule} from '@angular/material/legacy-button';
import {MatIconModule} from '@angular/material/icon';
import {MatLegacyMenuModule as MatMenuModule} from '@angular/material/legacy-menu';
import {MatLegacySlideToggleModule as MatSlideToggleModule} from '@angular/material/legacy-slide-toggle';
import { MediaCarouselTopMenuComponent } from './media-carousel-top-menu/media-carousel-top-menu.component';
import { ImageCarouselAnnotationPointsComponent } from './image-carousel-annotation-points/image-carousel-annotation-points.component';
import { ChangeMediaOrderMediaTypeComponent } from './change-media-order-media-type/change-media-order-media-type.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {MatLegacyCardModule as MatCardModule} from '@angular/material/legacy-card';
import {MatLegacyFormFieldModule as MatFormFieldModule} from '@angular/material/legacy-form-field';
import {MatLegacySelectModule as MatSelectModule} from '@angular/material/legacy-select';
import {RouterModule} from '@angular/router';
import {ThumbnailCarouselComponent} from './thumbnail-carousel/thumbnail-carousel.component';
import {
  ThumbnailCarouselNavButtonComponent
} from './thumbnail-carousel-nav-button/thumbnail-carousel-nav-button.component';
import {ThumbnailStackComponent} from './thumbnail-stack/thumbnail-stack.component';

@NgModule({
  imports: [
    CommonModule,
    MatDialogModule,
    SharedModule,
    DragulaModule,
    ObjectViewModule,
    MediaSelectorModule,
    MatSliderModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatSlideToggleModule,
    DragDropModule,
    MatCardModule,
    MatFormFieldModule,
    MatSelectModule,
    RouterModule
  ],
  exports: [
    MediaCarouselComponent,
    ChangeMediaOrderComponent
  ],
  declarations: [
    MediaCarouselComponent,
    ChangeMediaOrderComponent,
    MediaCarouselTopMenuComponent,
    ImageCarouselAnnotationPointsComponent,
    ChangeMediaOrderMediaTypeComponent,
    ThumbnailCarouselComponent,
    ThumbnailCarouselNavButtonComponent,
    ThumbnailStackComponent
  ]
})
export class MediaCarouselModule {
}
